const initialFilters = {
  assignment: '',
  assignmentType: '',
  track: '',
  cohort: '',
  assignmentGradeMin: '0',
  assignmentGradeMax: '100',
  courseGradeMin: '0',
  courseGradeMax: '100',
};

export default initialFilters;
